let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lTv1B")).then(() => parcelRequire('4HuAu'));